export type RegistrationAssessment = {
  id: string;
  registrationId: string;
  assessmentId: string;
};

export type SubmissionVisibility = 'visible' | 'hidden';
